import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    fechaPresupuestada: moment(new Date()).format('YYYY-MM-DD'),
    flujoFondosConceptoId: 0,
    flujoFondosConcepto: null,
    flujoFondosConceptoNombre: null,
    importe: '',
    observaciones: ''
};

const mutations = {
    updateField,

    'INICIALIZAR'(state) {
        state.fechaPresupuestada = moment(new Date()).format('YYYY-MM-DD');
        state.flujoFondosConceptoId = 0;
        state.flujoFondosConcepto = null;
        state.flujoFondosConceptoNombre = null;
        state.importe = '';
        state.observaciones = '';
    },
    'SET_FLUJO_FONDOS_CONCEPTO'(state, flujoFondosConcepto) {
        state.flujoFondosConcepto = flujoFondosConcepto;
        if (flujoFondosConcepto) {
            state.flujoFondosConceptoId = flujoFondosConcepto.id? flujoFondosConcepto.id : 0;
            state.flujoFondosConceptoNombre = flujoFondosConcepto.nombre? flujoFondosConcepto.nombre.trim() : 0;
        } else {
            state.flujoFondosConceptoId = 0;
            state.flujoFondosConceptoNombre = null;
        }
    },
};

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR');
            resolve();
        })
    },
    setFlujoFondosConcepto: ( { commit }, flujoFondosConcepto) => {
        return new Promise((resolve, reject) => {
            commit('SET_FLUJO_FONDOS_CONCEPTO', flujoFondosConcepto);
            resolve();
        })
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let flujoFondosPresupuesto = {
                fechaPresupuestada: moment(state.fechaPresupuestada).format('YYYY-MM-DD'),
                flujoFondosConceptoId: state.flujoFondosConceptoId,
                importe: parseFloat(state.importe),
                observaciones: state.observaciones
            }

            apiAxios.post('flujo-fondos/presupuestos', flujoFondosPresupuesto)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}